import { Link, useLocation } from 'react-router-dom';
import {
  Home,
  Building2,
  CreditCard,
  Building,
  ClipboardCheck,
  History,
  BarChart3,
  Map,
  Compass,
} from 'lucide-react';

const navItems = [
  { path: '/', label: '홈', icon: Home },
  { path: '/complexes', label: '단지', icon: Building2 },
  { path: '/cards', label: '방문 카드', icon: CreditCard },
  { path: '/officetel-zones', label: '오피스텔', icon: Building },
  { path: '/field-survey', label: '현장조사', icon: ClipboardCheck },
  { path: '/field-survey/history', label: '조사이력', icon: History },
  { path: '/stats', label: '통계', icon: BarChart3 },
  { path: '/map-tools', label: '지도 도구', icon: Map },
  { path: '/map-meta', label: 'MAP META', icon: Compass },
];

const Navigation: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="hidden sm:block bg-white border-b border-gray-100">
      <div className="max-w-page-full mx-auto px-6">
        <div className="flex items-center h-14">
          <Link to="/" className="text-lg font-bold text-gray-900 mr-8 whitespace-nowrap">
            JW 구역
          </Link>
          <div className="flex items-center gap-1 overflow-x-auto scrollbar-hide">
            {navItems.map(item => {
              const Icon = item.icon;
              const active = isActive(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                    active
                      ? 'bg-brand-50 text-brand-700'
                      : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  <Icon size={16} strokeWidth={active ? 2.2 : 1.8} />
                  {item.label}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
